












import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import moment, {Moment} from "moment";
import {FORMAT_DATE_PICKER, FORMAT_DATE_TIME_PICKER} from "@/shared/constant";

@Component({
  name: "MillisecondDatePicker"
})
export default class extends Vue {
  @Prop({type: Boolean, default: false}) readonly showTime!: boolean;
  @Prop({type: Boolean, default: false}) readonly isEndDay!: boolean;
  @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
  @Prop({ default: 'default' }) readonly size!: 'default' | 'small' | 'large';

    @Model("change", {type: Number})
  readonly dateMls!: number;

  @Emit("change")
  handleChange(value?: Moment) {
    if (!value) return undefined;
    if (this.isEndDay)
      return moment(value).endOf('day').valueOf();
    if (this.showTime)
      return value?.valueOf();
    return moment(value).startOf('day').valueOf();
  }

  @Prop({type: String, default: "Chọn ngày"})
  readonly placeholder!: string;

  formatDatePicker = FORMAT_DATE_PICKER;
  formatDateTimePicker = FORMAT_DATE_TIME_PICKER;
  get dateMoment() {
    return this.dateMls ? moment(this.dateMls) : undefined;
  }
}
